export const phoneForCustomers = "8 800 200-90-02";
